import { render, staticRenderFns } from "./DealerRankingCard.vue?vue&type=template&id=73718c40&scoped=true"
import script from "./DealerRankingCard.vue?vue&type=script&lang=js"
export * from "./DealerRankingCard.vue?vue&type=script&lang=js"
import style0 from "./DealerRankingCard.vue?vue&type=style&index=0&id=73718c40&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73718c40",
  null
  
)

export default component.exports